const __DEV__ = !(process.env.NODE_ENV === "production");

export const debugLog = (info: any) => {
  // tslint:disable-next-line
  __DEV__ && console.log(info);
};
